import React from "react";

const CentralFinanceReporting = (
    <div>
        <h1>Title placeholder</h1>
        <p>Placeholder</p>
    </div>
)


export default CentralFinanceReporting;
